import React, { Fragment, useCallback, useEffect, useState } from "react";
import { FnBlock_UI } from 'components/BlockUI';

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { ColumnProps } from "components/TableUI/TableUI";
import { BtnAddTable, BtnCancel, BtnDeleteTable, BtnEditTable, BtnExcelTable, BtnPDFTable, BtnSaveIcon, BtnSearchTable, BtnViewTable, BtnCancelIcon, BtnSearch } from "components/Button";
import { Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import TableUI from "components/TableUI";
import { useLocation, useNavigate } from "react-router-dom";
import { SelectMultipleFormItem, TextBoxForm } from "components/Input";

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { DatePickerFromItem } from "components/Input/DatePicker";
import { AiFillEdit } from "react-icons/ai";
import { CheckboxGroupFormItem } from "components/Input/Checkbox";
import { Encrypt, undefinedOrNull } from "utilities/Function";
import Report_PDF from "./Report_PDF";
import moment from "moment";
import { AxiosPost, AxiosPostFileExcel } from "utilities/Axios";
import Report_Excel from "./Report_Excel";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#0053b5",
        color: theme.palette.common.white,
        border: '1px solid rgba(224, 224, 224, 1) !important',
        padding: '10px',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: '8px',
        border: '1px solid rgba(224, 224, 224, 1) !important',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function Report() {
    //#region State
    const navigate = useNavigate();
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const [ArrStatus, setArrStatus] = useState([]);
    const [lstPosition, setlstPositions] = useState([]);
    const [rowData, setrow] = useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setendDate] = useState(null);

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    //#endregion

    //#region Form YUP
    const objSchema = yup.object().shape({
        sUserName: yupFormSchemas.string("ชื่อ-นามสกุล", { required: false }),
    });

    const form = useForm({
        resolver: yupResolver(objSchema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError",
    });

    const objSchema2 = yup.object().shape({
        CheckboxFormItem: yupFormSchemas.stringArray("เลือกข้อมูลที่ต้องการ Export", { required: true }),
    });

    const form2 = useForm({
        resolver: yupResolver(objSchema2),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError",
    });

    //#endregion
    useEffect(() => {
        onPageLoadRegisterForm();
    }, [])

    const onPageLoadRegisterForm = () => {
        BlockUI();
        AxiosPost("Report/onGetDataAll", {}, (res) => {
            setArrStatus(res.lstStatus || []);
            setlstPositions(res.lstPosition || []);
            form.setValue("sStatus", ["109"]);
            onLoadData();
        }, null, null, null, () => {
            UnBlockUI();
        })
    }


    //#region Column
    const ColumnData: ColumnProps[] = [
        {
            id: "nNo",
            name: "ลำดับ",
            width: "5%",
            cellAlign: "center",
            headerAlign: "center",
        },
        {
            id: "sRegisterCode",
            name: "เลขที่ใบสมัคร",
            width: "5%",
            cellAlign: "center",
            headerAlign: "center",
        },
        {
            id: "sIDCard",
            name: "เลขบัตรประชาชน",
            width: "5%",
            cellAlign: "center",
            headerAlign: "center",
        },
        {
            id: "sName",
            name: "ชื่อ-นามสกุล",
            width: "15%",
            cellAlign: "left",
            headerAlign: "center",
        },
        {
            id: "sPosition",
            name: "ตำแหน่ง",
            width: "15%",
            cellAlign: "left",
            headerAlign: "center",
        },
        {
            id: "sContractStart",
            name: "วันที่เริ่มงาน",
            width: "5%",
            cellAlign: "center",
            headerAlign: "center",
        },
        {
            id: "sContractEnd",
            name: "วันที่หมดสัญญา",
            width: "5%",
            cellAlign: "center",
            headerAlign: "center",
        },
        {
            id: "sRegisterDate",
            name: "วันที่สมัคร",
            width: "5%",
            cellAlign: "center",
            headerAlign: "center",
        },
        {
            id: "sStatusName",
            name: "สถานะ",
            width: "8%",
            cellAlign: "center",
            headerAlign: "center",
        },
        {
            id: "sUpdateDate",
            name: "วันที่แก้ไข",
            width: "10%",
            cellAlign: "center",
            headerAlign: "center",
        },
        {
            id: "sUpdateName",
            name: "ผู้แก้ไข",
            width: "10%",
            cellAlign: "left",
            headerAlign: "center",
        },
        {
            id: "Button",
            name: "",
            width: "5%",
            cellAlign: "center",
            headerAlign: "center",
        }
    ];
    //#endregion

    const onEdit = (sID, sMode) => {
        navigate("/UserRecruitment_From?str=" + Encrypt(sID) + "&mode=report")
    }

    const onLoadData = () => {
        BlockUI();
        let obj = {
            sName: undefinedOrNull(form.getValues("sUserName")),
            sCode: undefinedOrNull(form.getValues("sCode")),
            sStartDate: undefinedOrNull(form.getValues("dStart"), "dateToString"),
            sEndDate: undefinedOrNull(form.getValues("dEnd"), "dateToString"),
            lstStatus: form.getValues("sStatus") || [],
            sPlaceOfWork:undefinedOrNull(form.getValues("sPlaceOfWork")),
            // lstPosition: form.getValues("sPosition") || [],
        };
        AxiosPost("Report/onLoadReportData", obj, (res) => {
            setrow(res || []);
        }, null, null, null, () => {
            UnBlockUI();
        })
    }
    const onExportExcel = () => {
        BlockUI();
        let obj = {
            sName: undefinedOrNull(form.getValues("sUserName")),
            sCode: undefinedOrNull(form.getValues("sCode")),
            sStartDate: undefinedOrNull(form.getValues("dStart"), "dateToString"),
            sEndDate: undefinedOrNull(form.getValues("dEnd"), "dateToString"),
            lstStatus: form.getValues("sStatus") || [],
            lstPosition: form.getValues("sPosition") || [],
            lstFilterExport: form2.getValues("CheckboxFormItem") || [],
        };
        let fileName = `RecruitmentList_${moment().format('yyyyMMDDHHmmss')}.xlsx`;
        AxiosPostFileExcel("Report/onExportExcel", obj, fileName, () => {
            UnBlockUI();
        });
    };
    return (
        <>
            <FormProvider {...form}>
                <Grid item container direction="row" xs={12} md={12} spacing={2} marginBottom={1}>
                    <Grid item md={1} xs={12}>
                        <div className="buttonExportexcel" onClick={handleClickOpen}>
                            <div className="button-wrapper">
                                <div className="text2">Export excel</div>
                                <span className="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="2em" height="2em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"></path></svg>
                                </span>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={12} container direction="row" spacing={1}>
                        <Grid item xs={12} md={2.5}>
                            <TextBoxForm
                                name='sPlaceOfWork'
                                label='สถานที่ทำงาน'
                                fullWidth
                                maxLength={250}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2.5}>
                            <TextBoxForm
                                name='sCode'
                                label='เลขที่ใบสมัคร / เลขที่บัตรประชาชน'
                                fullWidth
                                maxLength={100}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextBoxForm
                                name='sUserName'
                                label='ชื่อ-นามสกุล'
                                fullWidth
                                maxLength={150}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <DatePickerFromItem
                                name='dStart'
                                label='วันที่เริ่มงาน'
                                openTo="day"
                                disabled={false}
                                maxDate={endDate}
                                onChange={(e) => {
                                    setStartDate(e);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <DatePickerFromItem
                                name='dEnd'
                                label='วันที่หมดสัญญา'
                                openTo="day"
                                minDate={startDate}
                                disabled={false}
                                onChange={(e) => {
                                    setendDate(e);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={2.5}>
                            <SelectMultipleFormItem
                                name='sStatus'
                                label='สถานะ'
                                fullWidth
                                options={ArrStatus}
                                disabled={false}
                            />
                        </Grid>
                        {/* <Grid item xs={12} md={2.5}>
                                <SelectMultipleFormItem
                                    name='sPosition'
                                    label='ตำแหน่ง'
                                    fullWidth
                                    options={lstPosition}
                                    disabled={false}
                                />
                            </Grid> */}
                        {/* <Grid item >
                            <BtnSearchTable onClick={() => { onLoadData() }} />
                        </Grid> */}
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <Grid marginTop={0} md={12} container direction="row" alignItems="center" justifyContent="center" sx={{}}>
                            <BtnSearch style={{ width: "130px", marginLeft: "10px" }} onClick={() => { onLoadData() }}/>
                        </Grid>
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <Paper sx={{ width: '100%' }}>
                            <TableContainer sx={{ maxHeight: 600 }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <StyledTableRow>
                                            {ColumnData.map((column) => (
                                                <StyledTableCell
                                                    key={column.id}
                                                    align={column.headerAlign}
                                                    style={{ width: column.width }}
                                                >
                                                    {column?.name}
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rowData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                            return (
                                                <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.nID}>
                                                    {ColumnData.map((column) => {
                                                        const value = row[column.id];
                                                        let sStatusbackgroundColor = "";
                                                        let sStatuColors = "";
                                                        switch (row.nStatusID) {
                                                            case 85: {
                                                                sStatusbackgroundColor = "rgb(255 248 233)";
                                                                sStatuColors = "rgb(165, 94, 0)";
                                                            }
                                                                break;
                                                            case 109: {
                                                                sStatusbackgroundColor = "rgb(19 191 0)";
                                                                sStatuColors = "rgb(185 255 157)"
                                                            }
                                                                break;
                                                            case 110: {
                                                                sStatusbackgroundColor = "#FF6969";
                                                                sStatuColors = "#F1EFEF"
                                                            }
                                                                break;
                                                            case 111:
                                                            case 112: {
                                                                sStatusbackgroundColor = "#D83F31";
                                                                sStatuColors = "#F1EFEF"
                                                            }
                                                                break;
                                                        }
                                                        return (
                                                            <>
                                                                {column.id === "Button" ?
                                                                    <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                        <div style={{ display: "inline-flex", textAlign: "center" }}>
                                                                            <BtnViewTable title="ข้อมูล" style={{ marginLeft: "5px" }} onClick={() => onEdit(row.nID, row.sIDCard)} />
                                                                        </div>
                                                                    </StyledTableCell>
                                                                    :
                                                                    (column.id === "sStatusName" ?
                                                                        <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                            <Chip
                                                                                size="small"
                                                                                label={row.sStatusName}
                                                                                style={{
                                                                                    color: sStatuColors,
                                                                                    backgroundColor: sStatusbackgroundColor,
                                                                                    margin: "0.2rem",
                                                                                }}
                                                                            />
                                                                        </StyledTableCell>
                                                                        :
                                                                        <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                            {value}
                                                                        </StyledTableCell>
                                                                    )
                                                                }
                                                            </>
                                                        );
                                                    })}
                                                </StyledTableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 100]}
                                component="div"
                                count={rowData.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </FormProvider>
            <Dialog
                maxWidth={"lg"}
                fullWidth={true}
                open={open}
                onClose={handleClose}
                sx={{ borderRadius: "23px", zIndex: 2 }}
            >
                <DialogTitle style={{
                    borderBottom: "1px solid #FD8D14"
                }}><AiFillEdit /> เลือกข้อมูลที่ต้องการ Export</DialogTitle>
                <DialogContent>
                    {/* <Box
                            noValidate
                            component="form"
                            sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            m: 'auto',
                            width: 'fit-content',
                            }}
                        > */}
                    <FormProvider {...form2}>
                        <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1} marginTop={1}>
                            <Grid item md={12} xs={12}>
                                <CheckboxGroupFormItem label="" name={"CheckboxFormItem"} AllowCheckAll options={[
                                    { value: "sRegisterCode", label: "เลขที่ใบสมัคร" },
                                    { value: "sIDCard", label: "เลขที่บัตรประชาชน" },
                                    { value: "dIDcardExpiration", label: "วันที่หมดอายุ" },
                                    { value: "nPrefixID1", label: "คำนำหน้า-ไทย" },
                                    { value: "sFirstName_TH", label: "ชื่อ-ไทย" },
                                    { value: "sLastName_TH", label: "นามสกุล-ไทย" },
                                    { value: "nPrefixID2", label: "คำนำหน้า-อังกฤษ" },
                                    { value: "sFirstName_EN", label: "ชื่อ-อังกฤษ" },
                                    { value: "sLastName_EN", label: "นามสกุล-อังกฤษ" },
                                    { value: "sNickname", label: "ชื่อเล่น" },
                                    { value: "dBirthday", label: "วันเกิด" },
                                    { value: "nNationalityID", label: "สัญชาติ" },
                                    { value: "nEthnicityID", label: "เชื้อชาติ" },
                                    { value: "nReligionID", label: "ศาสนา" },
                                    { value: "nSexID", label: "เพศ" },
                                    { value: "nMaritalStatusID", label: "สถานภาพสมรส" },
                                    { value: "nWeight", label: "น้ำหนัก" },
                                    { value: "nHeight", label: "ส่วนสูง" },
                                    { value: "nMilitaryStatusID", label: "สถานภาพทางทหาร" },
                                    { value: "nPositionID", label: "ตำเหน่งงานที่สนใจ" },
                                    { value: "nSalary", label: "เงินเดือนขั้นต่ำที่คาดหวัง" },
                                    { value: "nNewSourceID", label: "แหล่งข่าวการสมัครงาน" },
                                    { value: "nRecruitmentID", label: "ชื่อเจ้าหน้าที่สรรหา" },
                                    { value: "Addass1", label: "ที่อยู่ตามทะเบียนบ้าน" },
                                    { value: "Addass2", label: "ที่อยู่ปัจจุบัน" },
                                    { value: "sEmail", label: "อีเมล์" },
                                    { value: "sIDLine", label: "ID Line" },
                                    { value: "sFacebook", label: "Facebook" },
                                    { value: "sMobileNumber", label: "เบอร์มือถือ" },
                                    { value: "sContact1", label: "บุคคลที่ติดต่อกรณีเร่งด่วน คนที่ 1" },
                                    { value: "sContact2", label: "บุคคลที่ติดต่อกรณีเร่งด่วน คนที่ 2" },
                                    { value: "Consideration", label: "ข้อมูลการพิจารณาพนักงาน" },
                                ]}
                                />
                            </Grid>
                        </Grid>
                    </FormProvider>
                    {/* </Box> */}
                </DialogContent>
                <DialogActions>
                    {/* <Button onClick={handleClose}>Close</Button> */}
                    {/* <BtnCancelIcon onClick={handleClose} /> */}
                    <div className="buttonExportexcel" onClick={form2.handleSubmit(() => { onExportExcel(); })}>
                        <div className="button-wrapper">
                            <div className="text2">ยืนยัน Export</div>
                            <span className="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="2em" height="2em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"></path></svg>
                            </span>
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    )
}